import * as React from "react";
const SvgFiRrInventoryAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-inventory-alt_svg__a)">
      <path
        fill="#062147"
        d="M10 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V7c0-2.757 2.243-5 5-5h.171A3.01 3.01 0 0 1 8 0h2c1.304 0 2.416.836 2.829 2H13c2.757 0 5 2.243 5 5v3a1 1 0 1 1-2 0V7c0-1.654-1.346-3-3-3h-1a1 1 0 0 1-1-1c0-.552-.449-1-1-1H8c-.551 0-1 .449-1 1s-.448 1-1 1H5C3.346 4 2 5.346 2 7v12c0 1.654 1.346 3 3 3h4a1 1 0 0 1 1 1M8.793 6.713 6.566 8.94a.205.205 0 0 1-.286.006L5.175 7.933a1 1 0 1 0-1.351 1.475l1.105 1.013a2.2 2.2 0 0 0 3.051-.066l2.227-2.227a.999.999 0 1 0-1.414-1.414zm0 6.08L6.566 15.02a.206.206 0 0 1-.286.006l-1.105-1.013a1 1 0 0 0-1.351 1.475l1.105 1.013a2.2 2.2 0 0 0 3.051-.066l2.227-2.227a1 1 0 0 0 0-1.414 1 1 0 0 0-1.414-.001M24 16.5v4c0 1.93-1.57 3.5-3.5 3.5h-5c-1.93 0-3.5-1.57-3.5-3.5v-4c0-1.93 1.57-3.5 3.5-3.5h5c1.93 0 3.5 1.57 3.5 3.5m-2 0c0-.827-.673-1.5-1.5-1.5h-5c-.827 0-1.5.673-1.5 1.5v4c0 .827.673 1.5 1.5 1.5h5c.827 0 1.5-.673 1.5-1.5zm-3 .5h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m-5-7a1 1 0 0 0-1-1h-1.5a1 1 0 0 0 0 2H13a1 1 0 0 0 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-inventory-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInventoryAlt;
